import IndexPage from '../pages/individuals/index.vue'
import OnboardingPage from '../pages/individuals/onboarding.vue'
import AgreementPage from '../pages/individuals/agreement.vue'
import GroupIndexPage from '../pages/groups/index.vue'
import WorkspaceOnboardingPage from '@/modules/workspace/pages/workspace-onboarding-page.vue'

export default [
  {
    component: IndexPage,
    name: 'connecting.individuals',
    path: '/:slug/connecting/individual/:individualId',
  },
  {
    component: OnboardingPage,
    name: 'connecting.onboarding',
    path: '/:slug/connecting/individual/:individualId/onboarding',
  },
  {
    component: OnboardingPage,
    name: 'connecting.individuals.edit',
    path: '/:slug/connecting/individual/:individualId/edit',
  },
  {
    component: AgreementPage,
    name: 'connecting.agreement',
    path: '/:slug/connecting/individual/:individualId/agreement/:connectionId',
  },
  {
    component: GroupIndexPage,
    name: 'connecting.groups',
    path: '/:slug/connecting/connections',
  },
  {
    component: WorkspaceOnboardingPage,
    name: 'connecting.groups.edit',
    path: '/:slug/connecting/connections/edit',
  },
]
